export default "__VITE_PUBLIC_ASSET__4d72bfbe__"